import docCookies from './docCookies';

$(function(){

    // check if placeholder contains a content-section
    let $first_content_section = $('.popup-container').find('.content-section').first();
    let popup_container_has_content = $first_content_section.length > 0 && true;
    let is_logged_in = $('html').hasClass('cms-ready');

    // only do stuff when the popup actually contains content
    if (popup_container_has_content && is_logged_in === false) {

        // build unique cookie name according to content section ID
        let id = $first_content_section.attr('data-id');

        // in case cookie is NOT set, show the modal
        if (docCookies.getItem('popup-hidden-'+id) === null ) {
            // trigger modal delayed
            setTimeout(function(){
                $('.popup-trigger').trigger('click');
            },1500);
        }

        // when closing the default modal, set cookie
        $(window).on('default-modal:closed',function(){
            // init
            var one_month_in_seconds = 2592000;
            // write cookie
            docCookies.setItem('popup-hidden-'+id, 'true', one_month_in_seconds, '/');
        });
    }


});



// WEBPACK FOOTER //
// ./static/js/modules/popup.js